import { Col, Row } from "antd";
import { createContext, useContext } from "react";
import { UserContext } from "../../App";
import { Item } from "../Inventory/types";
import { DaysOff } from "./DaysOff";
import { Items } from "./Items";
import { Notifications } from "./Notifications";
import { Projects } from "./Projects";
import { GreetingMessage } from "./styledComponents";
import { DayOff, Notification, Project, Task } from "./types";
import useDashboard from "./useDashboard";

interface DashboardContextInterface {
  projects: Project[];
  loadingProjects: boolean;
  notifications: Notification[];
  loadingNotifications: boolean;
  tasks: Task[];
  loadingTasks: boolean;
  items: Item[];
  loadingItems: boolean;
  daysOff: DayOff[];
  loadingDaysOff: boolean;
  markTaskDone(taskId: string): void;
}
//@ts-ignore
export const DashboardContext = createContext<DashboardContextInterface>();

export const Dashboard = () => {
  const { user } = useContext(UserContext);

  const ret = useDashboard();

  return (
    <DashboardContext.Provider value={ret}>
      <div>
        <GreetingMessage>
          Hello {user?.firstName} 👋🏻. What are you working on today?
        </GreetingMessage>
        <div>
          <Row>
            <Col span={24} style={{ padding: "5px" }}>
              <Projects />
            </Col>
          </Row>
          <Row gutter={8} style={{ padding: "5px", alignItems: "stretch" }}>
            <Col span={8} style={{ display: "flex", flexDirection: "column" }}>
              <Notifications />
            </Col>
            <Col span={8} style={{ display: "flex", flexDirection: "column" }}>
              <DaysOff />
            </Col>
            <Col span={8} style={{ display: "flex", flexDirection: "column" }}>
              <Items />
            </Col>
          </Row>
        </div>
      </div>
    </DashboardContext.Provider>
  );
};
